import {
  ContentChild,
  Directive,
  Input,
} from '@angular/core';
import { AbstractTableRowAction } from './abstract-table-row-action';
import { TableRowActionExecutingDirective } from './table-row-action-executing.directive';

@Directive({
  selector: 'button[eurogardTableRowAction]',
  standalone: true,
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [ 'errorMessage', 'successMessage', 'refresh', 'color' ],
})
export class TableRowActionDirective<Data extends Record<string, any>> extends AbstractTableRowAction<Data> {

  @Input({ required: true, alias: 'eurogardTableRowAction' })
  type!: string;

  @Input({ required: true })
  element!: Data;

  @ContentChild(TableRowActionExecutingDirective)
  declare protected readonly executingDirective?: TableRowActionExecutingDirective;

  protected getElementList(): Data[] {
    return [ this.element ];
  }

}
